<template>
    <div class="px-3 py-2 bg-light" :class="width">
        <div v-if="distance">
            <span class="text-base">Distance:</span>&nbsp;
            <span class="text-primary text-base break-all">{{ Number(distance).toFixed(2) }}m</span>
        </div>

        <div v-for="row in rows">
            <span class="text-base">{{ fields[row.field_id]?.fac_search_name ?? '' }}:</span>&nbsp;
            <div class="text-primary text-base break-all" v-html="store.data.fac_type_memberships.mappedAnswer(fields[row.field_id], row.answer)" />
        </div>

        <a 
            v-if="hasProfileButton && profileUrl !== null"

            class="btn btn--secondary mt-3" 
            :href="profileUrl"
        >View Profile</a>
    </div>
</template>

<script setup>
    import { computed } from 'vue'
    import store from '@app/fac-search/state/store'

    const props = defineProps({
        member       : Object,
        membershipId : String,
        width        : {
            type    : String,
            default : 'w-56'
        },
        hasProfileButton: {
            type    : Boolean,
            default : true
        },
        distance: [String, Number]
    })

    const fields = computed(() => store.data.fac_type.fields.value)
    const rows = computed(() => store.memberFieldsForSection('main-card', props.member) ?? [])
    const profileUrl = computed(() => store.memberProfileUrl(props.membershipId) ?? null)
</script>